<template>
  <div>
    <fixed-header title="Warehouses List" :records="pageInfo.totalItems" hideNewOfferBtn />
    <div class="animated fadeIn BillPayments--BillPayments-list">
      <div class="card">
        <div class="card-body">
          <b-row class="search">
            <b-col cols="4">
              <b-form-input size="sm" class="mr-sm-2" placeholder="Search" left @input="onSearch" v-bind:value="searchQuery"></b-form-input>
            </b-col>
            <b-col cols="2">
              <b-form-checkbox
                @change="showInactive"
              >Show Inactive</b-form-checkbox>
            </b-col>
          </b-row>
          <grid-component
            isResizable
            isReorderable
            isSortable
            :gridId="gridId"
            :pageable="pageable"
            :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
            :take="pageInfo.pageSize"
            :itemData="itemData"
            :pageSizes="pageInfo.pageSize"
            :totalItems="pageInfo.totalItems"
            :fields="fields"
            :sortBy="pageInfo.sortBy"
            :sortOrder="pageInfo.sortOrder"
            :sortMethod="sortGrid"
            :onEdit="openEdit"
            :onDelete="onDelete"
            :styleCustom="'height: 775px'"
            :navigationField="'name'"
            @getData="onGetData"
            :isTblLoader="tblLoader"
            />
        </div>
        <edit-address
          :hideAddButton="true"
          :companyId="companyId"
          :id="activeEditId"
          ref="editModal"
          @hideModal="hideAddressModal"
          @saved="refreshWarehouses"
        ></edit-address>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { debounce } from 'lodash';

import { GRID_ID, GRID_PAGE_SIZES } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import EditWarehouse from './components/EditWarehouse/index';
import EditAddress from '@/pages/Company/components/CompanyDetails/tabs/Addresses/components/EditAddress';
import warehousesFields from './fields';
import { ACTIVE_TYPE_ID } from './module';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
  components: {
    EditWarehouse,
    GridSettings,
    GridComponent,
    EditAddress,
    FixedHeader
  },
  data() {
    return {
      prepareColumnsData,
      activeEditId: 0,
      fields: warehousesFields,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      companyId: 0
    }
  },
  metaInfo: () => ({
    title: 'Warehouse',
  }),
  computed: {
    ...mapGetters('warehouse', [
      'gridList',
      'pageInfo',
      'active',
      'searchQuery',
      'tblLoader'
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    gridId: function() {
      return GRID_ID.WAREHOUSE;
    },
    itemData() {
      if (this.gridList == undefined || !this.gridList.length) return [];
      return this.gridList;
    },
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
  },
  methods: {
    ...mapActions('warehouse', [
      'getAll',
      'sortGrid',
      'search',
      'getWarehousesExcel',
    ]),
    ...mapActions('address', [
      /*'deleteAddress',*/
      'deleteRecord'
    ]),
    ...mapActions('account', ['saveGridSettings']),
    ...mapMutations('warehouse',['setItem']),
    async onGetData(params) {
			await this.getAll(params);
		},
    onSearch: debounce(function(e) {
      this.search(e);
    }, SEARCH_DEBOUNCE_TIME),
    showInactive(inactiveVisible) {
      const byStatus = inactiveVisible ? ACTIVE_TYPE_ID.ALL : ACTIVE_TYPE_ID.ACTIVE;
      this.getAll(byStatus);
    },
    showAddModal() {
      this.$bvModal.show('edit-warehouse-modal');
    },
    openEdit(row) {
      this.activeEditId = row.id;
      this.companyId = row.accountId;
      // this.$bvModal.show('edit-warehouse-modal');
      this.$bvModal.show('edit-address-modal');
    },
    onDelete: async function({ id, name }) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete "${name}"?`});
      if (deleteConfirmed) {
        /*await this.deleteAddress(id);*/
        await this.deleteRecord(id);
        this.refreshWarehouses();
      }
    },
    refreshWarehouses() {
      this.getAll({});
    },
    async hideAddressModal() {
      this.activeEditId = 0;
      this.companyId = 0;
    },
  },
  async mounted() {
    this.$root.$on('bv::modal::hide', () => {
      this.activeEditId = 0;
      this.companyId = 0;
    })
    this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
    await this.getAll({});
  },
}
</script>

<style lang="scss">
.warehouse--warehouse-list {
  .tools > * {
      margin: 0 0 0 3px;
    }
  .search {
    margin-bottom: 1.25rem;
  }
  .b-pagination {
    justify-content: center;
  }
  table td {
    cursor: pointer;
  }
  .buttons-panel {
    text-align: right;
  }
}
</style>
